import { render, staticRenderFns } from "./examManager.vue?vue&type=template&id=8a5ac54e"
import script from "./examManager.vue?vue&type=script&lang=js"
export * from "./examManager.vue?vue&type=script&lang=js"
import style0 from "./examManager.vue?vue&type=style&index=0&id=8a5ac54e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports